import React from 'react'
import styled from 'styled-components';
import { device } from "../device";

const BlockParent = styled.div`
    padding-top: 64px;
    @media ${device.lg} {
        padding-top: 96px;
    }
`;

export default React.memo(BlockParent);